var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarkerPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4879 16.6362C23.7794 17.48 26.7785 19.407 26.7785 21.6492C26.7785 24.6691 21.3383 27.1171 14.6275 27.1171C7.91674 27.1171 2.47656 24.6691 2.47656 21.6492C2.47656 19.407 5.47566 17.48 9.76715 16.6362M14.6275 21.0416V4.03027L21.0891 8.00661C21.5604 8.29666 21.7961 8.44168 21.8712 8.62438C21.9368 8.78374 21.9316 8.96345 21.857 9.11876C21.7714 9.29682 21.5278 9.42801 21.0405 9.69038L14.6275 13.1435",
    stroke: "#F5F5F5",
    strokeWidth: 2.4302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerPin);
export default __webpack_public_path__ + "static/media/marker-pin.86016bf2363bf4a06056018d86c06e32.svg";
export { ForwardRef as ReactComponent };